import { EnvironmentInterface } from './environment.interface';

export const environment: EnvironmentInterface = {
    production: JSON.parse('true'),
    showDevBox: JSON.parse('false'),
    showOcktoDevBox: JSON.parse('false'),
    enableAnalytics: JSON.parse('true'),
    cordIamBaseUrl: 'https://inzichtgesprek.nl/access-identity/api',
    cordFinanceBaseUrl: 'https://inzichtgesprek.nl/cordfinance/api',
    ocktoReceiverBaseUrl: 'https://inzichtgesprek.nl/ockto-receiver/api',
    univeWrapperBaseUrl: 'https://inzichtgesprek.nl/unive-wrapper/api',
    analyticsUrl: 'https://cdn.unive.nl/assets/external-apps/analytics/adv-dcf-ru-unive-nl.js',
    useEncryption: JSON.parse('true'),
    sessionTimeToLive: JSON.parse('120'),
};
